import { Meta, PaginationMeta } from "@/types";
import { axiosInstance } from "../clients";
import { Organisation } from "@/types/User";

async function listOrganisations(params: {
  page?: string;
  search?: string;
  region?: string;
  sort?: string;
  dir?: string;
  archived?: string;
}): Promise<{ meta?: PaginationMeta | Meta; data: { organisations: Organisation[] } }> {
  return (await axiosInstance.get(`/v1/organisations`, { withCredentials: true, params })).data;
}

async function createOrganisation(organisation: any): Promise<{ data: { organisation: Organisation } }> {
  return (await axiosInstance.post(`/v1/organisations`, organisation, { withCredentials: true })).data;
}

async function toggleTrainerFee(organisation_id: Organisation["id"]): Promise<{ data: { organisation: Organisation } }> {
  return (await axiosInstance.post(`/v1/organisations/${organisation_id}/payment`, { withCredentials: true })).data;
}

async function listSubOrganisations(): Promise<{ data: { sub_organisations: string[] } }> {
  return (await axiosInstance.get(`/v1/sub-organisations`, { withCredentials: true })).data;
}

async function canDeleteOrganisation(organisation_id: Organisation["id"]): Promise<{ data: { canDelete: boolean } }> {
  return (await axiosInstance.get(`/v1/organisations/${organisation_id}/canDelete`, { withCredentials: true })).data;
}

async function deleteOrganisation(organisation_id: Organisation["id"]): Promise<{ data: { organisation: Organisation } }> {
  return (await axiosInstance.delete(`/v1/organisations/${organisation_id}`, { withCredentials: true })).data;
}

async function archiveOrganisation(organisation_id: Organisation["id"]): Promise<{ data: { organisation: Organisation } }> { 
  return (await axiosInstance.post(`/v1/organisations/${organisation_id}/archive`, {}, { withCredentials: true })).data;
}

async function unarchiveOrganisation(organisation_id: Organisation["id"]): Promise<{ data: { organisation: Organisation } }> {
  return (await axiosInstance.post(`/v1/organisations/${organisation_id}/unarchive`, {}, { withCredentials: true })).data;
}

async function updateOrganisation(organisation_id: Organisation["id"], data: { name: string }): Promise<{ data: { organisation: Organisation } }> {
  return (await axiosInstance.post(`/v1/organisations/${organisation_id}`, data, { withCredentials: true })).data;
}

export default {
  listOrganisations,
  toggleTrainerFee,
  createOrganisation,
  listSubOrganisations,
  canDeleteOrganisation,
  deleteOrganisation,
  archiveOrganisation,
  unarchiveOrganisation,
  updateOrganisation
};